
import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';

interface Connection {
  id: string;
  full_name: string;
  avatar_url?: string;
}

interface ChatHeaderProps {
  selectedUser: Connection;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ selectedUser }) => {
  return (
    <div className="p-4 border-b border-primary/20 bg-gradient-to-r from-primary/10 to-primary/5 flex items-center">
      <Avatar className="h-10 w-10 mr-3 ring-2 ring-primary/30">
        <AvatarImage src={selectedUser.avatar_url} />
        <AvatarFallback className="bg-primary/20 text-primary font-semibold">
          {selectedUser.full_name.charAt(0)}
        </AvatarFallback>
      </Avatar>
      <div>
        <h3 className="font-semibold text-foreground">{selectedUser.full_name}</h3>
        <p className="text-sm text-primary">Online</p>
      </div>
    </div>
  );
};

export default ChatHeader;
